import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
} from "constants/FormatDataContanst";

export const getStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      //"Chờ duyệt"
      text: "Chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_REJECT]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_APPROVE]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_RR]: {
      //"Từ chối tiếp nhận duyệt",
      text: "Từ chối tiếp nhận duyệt",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_RRE]: {
      //"Từ chối tiếp nhận thay đổi"
      text: "Từ chối tiếp nhận thay đổi",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      // Đã tiếp nhận duyệt
      text: "Đã tiếp nhận duyệt",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_ARE]: {
      // Đã tiếp nhận thay đổi
      text: "Đã tiếp nhận thay đổi",
      badgeColor: "badge-soft-info",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};
